import createVueApp from '@phoenix/createVueApp';
import { PhxVideoPlayer } from '@phx-styleguides/als';

document.querySelectorAll('.phoenix-video-player').forEach((el) => {
  const app = createVueApp();
  app.component('PhxVideoPlayer', PhxVideoPlayer);
  app.mount(el);
});
